import React, { useState } from "react";
import styles from './ContactUsForm.module.css';
import emailjs from '@emailjs/browser';

const ContactUsForm = () =>{

    const [formContent, setFormContent ] = useState({
        name:"",
        email:"",
        subject:"",
        message:""
    });

    const handleChange = ( event ) =>{
        const { value, name } = event.target;

        setFormContent(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const handleSubmit = (e) => {
        e.preventDefault();
    
        const templateParams = {
            name: formContent.name,
            email: formContent.email,
            subject: formContent.subject,
            message: formContent.message,
            time: new Date().toLocaleString()
        };
    
        emailjs.send(
            "service_y16k7gd",
            "template_a1aquxv",
            templateParams,
            "GSwVkw5Ou3yGDpvCa"
        )
        .then(() => {
            alert("Email sent successfully!");
            setFormContent({
                name:"",
                email:"",
                subject:"",
                message:""
            });
        })
        .catch((error) => {
            console.error(error);
            alert("Failed to send email");
        });
    };

    return(
        <>
            <div className={`container ${styles.contain} overflow-hidden`}>
                <p className={`${styles.heading} mx-auto`}>We&apos;d Love to Hear From You</p>

                <form onSubmit={handleSubmit}>
                    <div className="row">

                        <div className="col-md-6" style={{textAlign: 'left'}}>
                            <label className={styles.label}>Name</label><br/>
                            <input name="name" value={formContent.name} onChange={handleChange} className={styles.input} type="text" required />

                            <label className={styles.label}>Email</label><br/>
                            <input name="email" value={formContent.email} onChange={handleChange} className={styles.input} type="email" required />

                            <label className={styles.label}>Subject</label><br/>
                            <input name="subject" value={formContent.subject} onChange={handleChange} className={styles.input} type="text" required />
                        </div>

                        <div className="col-md-6" style={{textAlign: 'left'}}>
                            <label className={styles.label}>Message</label><br/>
                            <textarea name="message" value={formContent.message} onChange={handleChange} className={`${styles.input} ${styles.msg}`} required />

                            <div style={{textAlign:'right'}}>
                                <button type="submit" className={`btn custom_btn ${styles.btn}`}>
                                    SEND
                                </button>
                            </div>
                        </div>

                    </div>
                </form>
            </div>
        </>
    )
}

export default ContactUsForm;
